@if (isVisible) {
  <div
    [class.w-full]="useMobileView"
    @slideDown
    class="block overflow-hidden bg-white p-[0.5rem] md:hidden">
    <app-email-search-input
      (searchEventEmitter)="search($event)"
      (valueChangedEventEmitter)="onSearchValueChanged($event)"
      (hideNotificationsEmitter)="onHideNotificationsChanged($event)"
      [search]="searchValue"
      [isDefaultSearchParams]="isDefaultSearchParams"
      [fullWidth]="useMobileView"
      [hasFilters]="!!infoOpenedMailAccount?.filter"></app-email-search-input>
  </div>
}
<div class="toolbar relative">
  <div class="flex-none">
    <button tourAnchor="leftMenu" (click)="leftMenuClicked()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="ml-auto block md:hidden">
    <button mat-icon-button type="submit" (click)="toggleVisibility()">
      <mat-icon>search</mat-icon>
    </button>
  </div>
  <div class="text-start lg:mx-[10px]">
    @if (isVisibleFolderName()) {
      <app-email-folder-name />
    }
  </div>
  <div
    class="flex hidden justify-center px-1 md:block md:px-0"
    tourAnchor="searchBar">
    <div [class.w-full]="useMobileView">
      <app-email-search-input
        (searchEventEmitter)="search($event)"
        (startTour)="startTour()"
        (valueChangedEventEmitter)="onSearchValueChanged($event)"
        (hideNotificationsEmitter)="onHideNotificationsChanged($event)"
        [search]="searchValue"
        [isDefaultSearchParams]="isDefaultSearchParams"
        [fullWidth]="useMobileView"
        [hasFilters]="!!infoOpenedMailAccount?.filter"></app-email-search-input>
    </div>
  </div>
  <div class="flex items-center gap-2">
    @if (
      isVisibleFolderName() && isInbox && isAnyFolders && !isAllFoldersSelected
    ) {
      <mat-tab-group
        [(selectedIndex)]="selectedTabIndex"
        (selectedTabChange)="changeTab($event)"
        class="ml-[auto] !hidden sm:!flex"
        mat-align-tabs="end"
        animationDuration="0s"
        [disablePagination]="!useSmallDesktopView">
        @for (
          tab of [
            'inInboxTabItem',
            'toValidateInboxTabItem',
            'ReassignedInboxTabItem',
          ];
          track tab
        ) {
          <mat-tab>
            <ng-template mat-tab-label>
              @if (preRelease) {
                <span
                  [matBadge]="countBages[$index]"
                  matBadgeSize="small"
                  matBadgeOverlap="false"
                  >{{ tab | translate }}</span
                >
              } @else {
                <span
                  [matBadge]="
                    emailsPageStateService.counts?.[countBadgesKey[tab]]
                      ? emailsPageStateService.counts[countBadgesKey[tab]]
                      : undefined
                  "
                  matBadgeSize="small"
                  matBadgeOverlap="false">
                  {{ tab | translate }}
                </span>
              }
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
      <mat-select
        [value]="selectedTabIndex"
        (selectionChange)="selectionChange($event)">
        @for (
          item of [
            'inInboxTabItem',
            'toValidateInboxTabItem',
            'ReassignedInboxTabItem',
          ];
          track item;
          let index = $index
        ) {
          <mat-option [value]="index">
            <span>
              {{ item | translate }}
              <span class="badges">
                {{
                  emailsPageStateService.counts?.[countBadgesKey[item]]
                    ? emailsPageStateService.counts[countBadgesKey[item]]
                    : ''
                }}
              </span>
            </span>
          </mat-option>
        }
      </mat-select>
    }
  </div>
  <div class="flex">
    <button
      class="ml-auto"
      mat-icon-button
      matTooltip="{{ 'addressBookNavTab' | translate }}"
      (click)="goToAddressBook()"
    >
      <mat-icon>folder_shared</mat-icon>
    </button>
    <button
      class="ml-auto"
      matTooltip="{{ 'profile' | translate }}"
      mat-icon-button
      (click)="goToProfile()"
    >
      <mat-icon>person</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="rightMenuClicked()"
      matTooltip="{{ 'menu' | translate }}"
    >
      <span class="material-symbols-outlined"> apps </span>
    </button>
  </div>
</div>
